import { ViewportType } from 'game-ui-types'

export const betSliderConfig = {
    [ViewportType.MOBILE_PORTRAIT]: {
        betSliderWidth: 810,
        betSliderHeight: 100,
        sideExtraSpaceNoGap: 29,
        itemWidth: 136,
        gap: 12,
    },
    [ViewportType.MOBILE_LANDSCAPE]: {
        betSliderWidth: 810,
        betSliderHeight: 100,
        sideExtraSpaceNoGap: 35,
        itemWidth: 136,
        gap: 8,
    },
    [ViewportType.DESKTOP]: {
        betSliderWidth: 810,
        betSliderHeight: 100,
        sideExtraSpaceNoGap: 36,
        itemWidth: 136,
        gap: 8,
    },
}
